import { render, staticRenderFns } from "./ItemAlignment.vue?vue&type=template&id=6189070e&scoped=true&"
import script from "./ItemAlignment.vue?vue&type=script&lang=js&"
export * from "./ItemAlignment.vue?vue&type=script&lang=js&"
import style0 from "./ItemAlignment.vue?vue&type=style&index=0&id=6189070e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6189070e",
  null
  
)

export default component.exports